import { useState, useEffect } from 'react';
import AgendaNavigation from '../../components/AgendaNavigation/AgendaNavigation';
import AgendaNavigationMobile from '../../components/AgendaNavigationMobile/AgendaNavigationMobile';
import Footer from '../../components/Footer/Footer';
import MainHeader from '../../components/MainHeader/MainHeader';
import MobileHeader from '../../components/MobileHeader/MobileHeader';
import Venue from '../../components/Venue/Venue';
import WhyJoinComponent from '../../components/WhyJoinComponent/WhyJoinComponent';
import { AgendaTabData } from '../../data/AgendaTabData';
import './Main.scss';
import { useInView } from 'react-intersection-observer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import SignUpform from '../../components/SignUpform/SignUpform';
import TimeContainer from '../../components/TimeContainer/TimeContainer';
import Organizer from '../../components/Organizer/Organizer';

const Main = () => {
  const [start, setStart] = useState(false);
  const [showBtn, setShowBtn] = useState(false);

  const { ref, inView, entry } = useInView({
    threshold: 0
  });

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    if (entry) {
      setStart(true);
    }
  }, [inView]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        setShowBtn(true);
      } else {
        setShowBtn(false);
      }
    });
  }, []);

  return (
    <div className="main">
      <MainHeader />
      <MobileHeader />
      <TimeContainer />
      <SignUpform />
      <Venue />
      <div ref={ref}>
        <WhyJoinComponent start={start} />
      </div>
      <AgendaNavigation
        titleClassName={'main-agenda'}
        subtitleClassName={'main-agenda-subtitle'}
        title={'DIGITALIZACIJA OSIGURANJE TEHNOLOGIJA – DOT2026'}
        AgendaTabData={AgendaTabData}
      />
      <AgendaNavigationMobile />
      <Organizer titleClass={'organizer-main'} />
      <Footer />
      {showBtn && (
        <button onClick={goToTop} className="btn-top">
          <FontAwesomeIcon icon={faArrowUp} color="white" className="icon" />
        </button>
      )}
    </div>
  );
};

export default Main;
